import { extractArrayMessageData } from './MessageUtils.js';
export class BrowserWebSocket {
    constructor(address) {
        this.messageHandler = null;
        this.native = new WebSocket(address);
        this.address = address;
        this.native.onmessage = this.nativeMessageHandler.bind(this);
    }
    getAddress() {
        return this.address;
    }
    setOpenHandler(handler) {
        this.native.onopen = handler;
    }
    setCloseHandler(handler) {
        this.native.onclose = handler;
    }
    setErrorHandler(handler) {
        //this.native.onerror = handler;
    }
    setMessageHandler(handler) {
        this.messageHandler = handler;
    }
    send(message) {
        this.native.send(message);
    }
    close() {
        this.native.close();
    }
    readyState() {
        return this.native.readyState;
    }
    reset() {
        this.setOpenHandler(null);
        this.setCloseHandler(null);
        this.setErrorHandler(null);
        this.setMessageHandler(null);
        this.native.close();
    }
    async nativeMessageHandler(message) {
        if (!this.messageHandler) {
            return;
        }
        if (typeof message.data === 'string') {
            return this.messageHandler(message.data);
        }
        return this.messageHandler(await extractArrayMessageData(message.data));
    }
}
//# sourceMappingURL=BrowserWebSocket.js.map